// extracted by mini-css-extract-plugin
export default {"descrption":"Descrption_descrption__TaS+T","descrption__title":"Descrption_descrption__title__GTog9"};